import React from 'react';
import DepartmentPaymentRequests from '../../components/DepartmentPaymentRequests';

const PurchasePaymentRequests = () => {
  return <DepartmentPaymentRequests department="PURCHASE" departmentLabel="Purchase Dept" />;
};

export default PurchasePaymentRequests;
